import responsiveCallback from "./responsiveCallback";

responsiveCallback(1140, isMobile => {
  if (isMobile) {
    // $('.m-hero-video-autoplay').trigger('pause');
  } else {
    setTimeout(() => {
        $('.m-hero-video-autoplay').trigger('play');
    }, 500);
  }
});
